module.exports = __webpack_public_path__ + "static/media/hero-thumbanil.f112c368.png";